import cn from 'classnames';
import { Camera, Offline } from '@shared/assets';
import { useCoachQuery } from '@src/api/api-hooks/coaches/useCoachQuery.ts';
import { literalDuration } from './lib';
import * as st from './styles.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  coachId: number;
  isActive: boolean;
  mode: string;
  showMobile?: boolean;
}

const fields: {
  [x: string]: {
    cost: string;
    duration: string;
  };
} = {
  ON: {
    cost: 'consultation_cost',
    duration: 'consultation_duration',
  },
  OF: {
    cost: 'consultation_offline_cost',
    duration: 'consultation_offline_duration',
  },
};

export const ScheduleButton: React.FC<Props> = ({
  mode,
  isActive,
  coachId,
  showMobile = false,
  ...props
}) => {
  const { data: coach } = useCoachQuery({ id: String(coachId) });

  const getText = (mode: string) => {
    switch (mode) {
      case 'ON':
        return 'Онлайн';
      case 'OF':
        return 'Личный прием';
      default:
        break;
    }
  };

  const getDuration = (duration: string) => {
    const minutes = parseFloat(duration) * 30;
    return duration ? literalDuration(minutes) : '----';
  };

  const getPrice = (price?: number) => {
    return `${price ? price / 100 : `----`}`;
  };

  return !showMobile ? (
    <button className={cn(st.button, isActive && st.active)} {...props}>
      <div className={st.button__duration}>
        <div className={st.button__wrapper}>
          {mode === 'ON' && <Camera />}
          {mode === 'OF' && <Offline />}
        </div>
        <span className={st.button__time}>
          {coach && getDuration(coach[fields[mode].duration] as string)}
        </span>
      </div>
      <span className={st.button__type}>{getText(mode)}</span>
      <p className={st.button__price}>
        {coach && getPrice(coach[fields[mode].cost] as number)}{' '}
        <span className={st.button__currency}>RUB</span>
      </p>
    </button>
  ) : (
    <p className={st.coast}>
      {coach && getDuration(coach[fields[mode].duration] as string)} /{' '}
      {coach && getPrice(coach[fields[mode].cost] as number)} RUB
    </p>
  );
};
